import TabView from '@/components/base/TabView/TabView'
import { AppContext, useApp } from '@/hooks/useApp'
import { fontSize } from '@/styles/font'
import {
  type V1AppColorTheme,
  type V1Screen,
  type V1TabBarView,
  type V1ViewTabBar
} from 'mnvm-mypage-app-ts-if'
import { memo, useContext } from 'react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import styled from 'styled-components'
import ScreenByType from '../Screen/ScreenByType'

const StyledDiv = styled.div`
  max-width: 1080px;
  margin: 0 auto;
`
const StyledTabList = styled(TabList)<{ activebordercolor: V1AppColorTheme }>`
  display: flex;
  .selected {
    border-bottom: ${({ activebordercolor }) =>
      `2px solid ${activebordercolor.color ?? 'white'}`};
    font-weight: 700;
  }

  // react tab default
  margin: 0 0 10px;
  padding: 0;
  // border-bottom: 1px solid #aaa;
  font-size: ${fontSize.S};
`
const StyledTab = styled(Tab)`
  &:focus {
    outline: none;
  }
  flex-grow: 1;
  text-align: center;

  // react tab default
  display: inline-block;
  border: 1px solid transparent;
  border-bottom: none;
  bottom: -1px;
  position: relative;
  list-style: none;
  padding: 10px;
  cursor: pointer;
`

interface TabBarViewProps {
  view: V1TabBarView
  defaultIndex?: number
  screenBuilder?: (screen: V1Screen, tabBar?: V1ViewTabBar) => JSX.Element[]
}

export const TabBarView = ({
  defaultIndex,
  view,
  screenBuilder
}: TabBarViewProps): JSX.Element => {
  const { tabBars, screens } = view
  const app = useApp()
  const { dispatch } = useContext(AppContext)

  if (tabBars === undefined) return <></>

  const handleTabChange = (index: number): void => {
    const screenType = tabBars[index]?.screenType ?? ''
    dispatch({
      ...app,
      screenType
    })
  }

  return (
    <StyledDiv>
      <Tabs defaultIndex={defaultIndex} onSelect={handleTabChange}>
        <StyledTabList activebordercolor={app.theme.primaryMainColor}>
          {tabBars.map((e, index) => (
            <StyledTab
              selectedClassName="selected"
              key={(e.screenType?.toString() ?? '') + index.toString()}
            >
              {e.text}
            </StyledTab>
          ))}
        </StyledTabList>
        {tabBars.map((e, index) => (
          <TabPanel key={(e.screenType?.toString() ?? '') + index.toString()}>
            {screenBuilder !== undefined &&
            screens !== undefined &&
            screens.length > index ? (
              screenBuilder(screens[index], e)
            ) : (
              <ScreenByType screenType={e.screenType} />
            )}
          </TabPanel>
        ))}
      </Tabs>
    </StyledDiv>
  )
}

export default memo(TabView)
